import { handleResult } from 'modules/core/lib/handleMutation'

import useCreateUpsellRequest, { CreateProps } from 'modules/upsell/hooks/useCreateUpsellRequest'

/**
 * Creates an upsell request with proper error handling.
 * Throws an error if the request fails, making it compatible with components
 * that expect promise-based error handling.
 */
export const useCreateUpsellRequestWithErrorHandling = () => {
  const { create, loading, called } = useCreateUpsellRequest()

  const createWithErrorHandling = async (props: CreateProps): Promise<void> => {
    const result = await create(props)

    const handled = handleResult(result, () => {})
    if (!handled.success) {
      throw new Error('Failed to create upsell request')
    }
  }

  return {
    create: createWithErrorHandling,
    loading,
    called,
  }
}
